"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _debugLogger = _interopRequireDefault(require("../utils/debugLogger"));

var isAuthServerAvailable = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(baseSettings) {
    var controller, authority, debug, timeoutId;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            controller = new AbortController(); // don't call settings resolver in here, use baseSettings only otherwise http call
            // required to server that might not be available

            authority = baseSettings.authority, debug = baseSettings.debug;
            /* istanbul ignore next */

            timeoutId = setTimeout(function () {
              controller.abort();
            }, 5000);
            return _context.abrupt("return", fetch("".concat(authority, "/.well-known/openid-configuration"), {
              signal: controller.signal,
              mode: 'cors'
            }).then(function (data) {
              if (!data.ok) {
                throw new Error(data.statusText);
              }

              (0, _debugLogger.default)('auth server is available', debug);
              clearTimeout(timeoutId);
              return true;
            }).catch(function () {
              (0, _debugLogger.default)('auth server is not available', debug);
              clearTimeout(timeoutId);
              return false;
            }));

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function isAuthServerAvailable(_x) {
    return _ref.apply(this, arguments);
  };
}();

var _default = isAuthServerAvailable;
exports.default = _default;